let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
//let React = require("ES/lib/react");
let Modal = require("ES/widgets/Modal");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let esUtils = require("ES/utils/esUtils");
let FormUtils = require("../../../../../utils/FormUtils");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let ServiceForm = require("./ServiceForm");
let FormButtons = require("react-loose-forms.bootstrap3/layouts/FormButtons");
let SlideOpenDown = require("../../../../widgets/SlideOpenDown");
let ComputeBtnModal = AuthedUserSession.is_st_family ? require("./ComputeBtnModal") : null;
let createStandardEventForm = require("../../createStandardEventForm");
let Constants = require("../../../../../utils/Constants.js");


let DepositPercentForm = createStandardEventForm({
  eventToInitialValues(event) {
    return {
      depositPercent: event.depositPercent + "",
      depositLock: _.get(event, ["flags_as_map", "st_deposit_lock", "is_set"], false)
    };
  },
  buildSchema(props) {
    let r = {
      depositPercent: {
        label: "Dep %",
        type: "text",
        validate: FormUtils.v.blankOr(FormUtils.v.percent)
      }
    };
    if (AuthedUserSession.is_st_family && ((_.get(props, "event.childids", []).length > 0) || (Constants.EVENTTYPE_PD === _.get(props, "event.eventClass")))) {
      _.set(r, "depositLock", {
        label: "Lock Deposit",
        type: "checkbox"
      });
    }
    return r;
  },
  writeInputDataToEvent(data, event) {
    _.set(event, "depositPercent", esUtils.isBlank(data.depositPercent) ? null : esUtils.toInt(data.depositPercent));
    _.set(event, ["flags_as_map", "st_deposit_lock", "is_set"], _.get(data, "depositLock", false));
  },
  renderButtons() {
    let onDiscard = this.__discardChanges;
    let changes_made = this.Form_areChangesMade();
    return dd.div({className: "text-right"},
      SlideOpenDown({open: changes_made}, FormButtons({onDiscard}))
    );
  }
});

let serviceFee = function (service) {
  if (!service) {
    return "";
  }
  let isFlag = function (f) {
    return _.get(service, ["flags_as_map", f, "is_set"], false);
  };
  if (isFlag("free")) {
    return "Free";
  } else if (isFlag("bill_later")) {
    return "Actual";
  }

  return esUtils.format_currency(service.fee, 2);
};

let serviceDate = function (service) {
  let r = "";

  if (service.due) {
    r = esUtils.format_date(service.due, "mm/dd/yyyy");
  }

  return r;
};


let serviceDescription = function (service) {
  if (!service) {
    return "";
  }

  return dd.div(null, service.description);
};

module.exports = dd.createClass({
  getInitialState() {
    return {editing_id: null, show_compute_modal: false};
  },
  __setEditingId(id) {
    return _.bind(esUtils.wrapPreventDefault(function () {
      this.setState({editing_id: id});
    }), this);
  },
  __addRoyalties: esUtils.wrapPreventDefault(function () {
    radio("add_royalty_items").broadcast(this.props.event);
  }),
  __compute: esUtils.wrapPreventDefault(function () {
    this.setState({show_compute_modal: !this.state.show_compute_modal});
  }),
  render() {
    let {event, Displaylists, read_only} = this.props;
    let {editing_id, show_compute_modal} = this.state;

    let services = event.Service;
    let mp_services = event.MPServices; // service combined with payments
    let services_by_id = _.object(_.map(services, function (service) {
      _.set(service, ["payment"], _.get(mp_services, [service.id, "payment"]));
      return [service.id, service];
    }));

    if (!_.isEmpty(services) && AuthedUserSession.is_st_family) {
      //pivotal story #146093113
      services = _.sortByOrder(services, ['fee'], ['desc']);
    }

    return dd.div({className: "ServicesTable"},
      dd.table({className: "table table-responsive table-condensed" + (read_only || event.is_mp_event ? "" : " table-hover")},
        dd.thead(null,
          dd.tr(null,
            dd.th({style: {width: 1}}, "Code"),
            dd.th({style: {width: 1}}, "Due"),
            dd.th(null, "Description"),
            dd.th({style: {width: 1}}, "Amount")
          )
        ),

        _.isEmpty(services) ? null : dd.tbody(null,
          _.map(services, function (service) {
            let editable = !read_only && !event.is_mp_event;

            let classes = [];
            if (editable) {
              classes.push("editable");
            }

            return dd.tr({key: service.id, className: classes.join(" "), onClick: !editable ? null : this.__setEditingId(service.id)},
              dd.td(null, service.groupcode),
              dd.td(null, serviceDate(service)),
              dd.td(null, serviceDescription(service)),
              dd.td(null, serviceFee(service))
            );
          }, this)
        ),

        _.isEmpty(services) ? dd.tbody(null,
          dd.tr(null,
            dd.td({colSpan: 4, style: {textAlign: "center"}},
              "-- no services --"
            )
          )
        ) : null,

        (_.isEmpty(services) || (AuthedUserSession.is_st_family) || ('cs' === AuthedUserSession.privatelabel_code)) ? null : dd.tfoot(null,
          dd.tr({className: "servicetotal"},
            dd.td({colSpan: 3}, "TOTAL"),
            dd.td(null, esUtils.format_currency(_.reduce(services, function (sum, service) {
              return sum + parseFloat(service.fee);
            }, 0), 2) + (event.is_mp_event ? "*" : ""))
          )
        )
      ),
      event.is_mp_event ? null : dd.div({className: "row"},
        dd.div({className: "col-sm-5"},
          DepositPercentForm({event, Displaylists, read_only})
        ),
        read_only ? null : dd.div({className: "col-sm-7 text-right"},
          (AuthedUserSession.is_st_family) ? dd.button({className: "btn btn-default btn-sm", onClick: this.__addRoyalties},
            "Add Royalties"
          ) : null,
          " ",
          ComputeBtnModal ? dd.button({className: "btn btn-default btn-sm", onClick: this.__compute},
            "Compute"
          ) : null,
          " ",
          dd.button({className: "btn btn-default btn-sm", onClick: this.__setEditingId(0)},
            dd.i({className: "fa fa-plus"}), " Add Service"
          )
        )
      ),
      dd.div({className: "clearfix"}),
      show_compute_modal && !!ComputeBtnModal ? ComputeBtnModal({event, Displaylists, onClose: this.__compute}) : null,
      editing_id !== null ? Modal({
          title: editing_id > 0 ? "Edit Service" : "New Service",
          onClose: this.__setEditingId(null),
          buttons: []
        },
        ServiceForm({
          event,
          service: services_by_id[editing_id] || null,
          onCancel: this.__setEditingId(null),
          Displaylists
        })
      ) : null
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/services/ServicesTable.js